import * as React from "react";
import { Drawer, Toolbar, Divider, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const drawerWidth = "16em";
const collapsedWidth = "0em"; // Adjust collapsed width

export const MySidebar = ({ open, toggleDrawer, children }) => {
  // Persist scroll position across re-renders (route changes)
  const scrollTopRef = React.useRef(0);
  const paperRef = React.useRef(null);

  // Callback ref to attach scroll listener and restore position on the drawer paper
  const handlePaperRef = React.useCallback(
    (node) => {
      // Clean up previous listener
      if (paperRef.current) {
        paperRef.current.removeEventListener("scroll", handleScroll);
      }

      paperRef.current = node;

      if (node) {
        // Restore saved scroll position
        node.scrollTop = scrollTopRef.current;
        // Listen for future scroll events to persist position
        node.addEventListener("scroll", handleScroll, { passive: true });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleScroll = React.useCallback((e) => {
    scrollTopRef.current = e.target.scrollTop;
  }, []);

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={open}
      PaperProps={{
        ref: handlePaperRef,
      }}
      sx={{
        width: open ? drawerWidth : collapsedWidth,
        flexShrink: 0,
        transition: "width 0.3s ease",
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : collapsedWidth,
          transition: "width 0.3s ease",
          boxSizing: "border-box",
          backgroundColor: "#1C1C1E",
          padding: "8px",
          overflowX: "hidden",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#555",
            borderRadius: "2px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#777",
          },
        },
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {open && (
          <img
            src="/Assets/Logos/sidebar-logo.svg"
            alt="Company Logo"
            loading="lazy"
            width="100%"
          />
        )}
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftIcon sx={{ color: "#fff" }} />
        </IconButton>
      </Toolbar>
      <Divider />
      {children}
    </Drawer>
  );
};
